import request from '@/utils/request';

// 折扣活动列表
export function queryDiscountActivityPageList(data) {
  return request({
    url: '/discount/activity/queryDiscountActivityPageList',
    method: 'POST',
    data
  });
}
// 折扣活动列表-删除
export function removeDiscountActivityById(data) {
  return request({
    url: '/discount/activity/removeDiscountActivityById',
    method: 'POST',
    data
  });
}
// 折扣活动列表-新增
export function saveDiscountActivity(data) {
  return request({
    url: '/discount/activity/saveDiscountActivity',
    method: 'POST',
    data
  });
}
// 折扣活动列表-修改
export function updateDiscountActivity(data) {
  return request({
    url: '/discount/activity/updateDiscountActivity',
    method: 'POST',
    data
  });
}
// 折扣活动列表-修改明细
export function fetchDiscountActivityDetailById(data) {
  return request({
    url: '/discount/activity/fetchDiscountActivityDetailById',
    method: 'POST',
    data
  });
}
// 折扣商品-商品列表
export function queryDiscountGoodsPageList(data) {
  return request({
    url: '/discount/goods/queryDiscountGoodsPageList',
    method: 'POST',
    data
  });
}
// 折扣商品-新增
export function saveDiscountGoods(data) {
  return request({
    url: '/discount/goods/saveDiscountGoods',
    method: 'POST',
    data
  });
}
// 折扣商品-删除
export function removeDiscountGoodsById(data) {
  return request({
    url: '/discount/goods/removeDiscountGoodsById',
    method: 'POST',
    data
  });
}
// 折扣商品-可用商品列表
export function goodsListInfo(data) {
  return request({
    url: '/discount/goods/queryEnableGoodsPageList',
    method: 'POST',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/discount.js